<template>
    <Layout>
        <div class="insights-alerts col-12">
            <Breadcrumb :items="breadcrumbItems" />
            <InsightsCardsBlock />
        </div>
    </Layout>
</template>

<script>
import Layout from '@layouts/main'
import Breadcrumb from '@/src/components/Breadcrumb.vue'
import InsightsCardsBlock from '@/src/components/dashboards/InsightsCardsBlock.vue'

const i18nKey = 'INSIGHTS'

export default {
    name: 'AlertsIndex',
    components: { Layout, Breadcrumb, InsightsCardsBlock },
    computed: {
        breadcrumbItems() {
            return [
                { text: 'Home', href: '/' },
                { text: this.getI18n('COMMON', 'intelligence') || 'Intelligence', active: false },
                { text: this.getI18n(i18nKey, 'TITLES.alerts_panel') || 'Painel de alertas', active: true },
            ]
        },
    },
}
</script>

<style scoped>
.insights-alerts {
    padding-bottom: 2rem;
}
</style>
